module.exports = __webpack_public_path__ + "img/youtube.6aa1ff1.png";